// import { morph } from '@theme/morph';
// import { Component } from '@theme/component';
// import { CartUpdateEvent, ThemeEvents } from '@theme/events';
// import { DialogComponent, DialogCloseEvent } from '@theme/dialog';
// import { mediaQueryLarge, isMobileBreakpoint, getIOSVersion } from '@theme/utilities';

// export class QuickAddComponent extends Component {
//   /** @type {AbortController | null} */
//   #abortController = null;
//   /** @type {Map<string, Element>} */
//   #cachedContent = new Map();

//   get productPageUrl() {
//     const productCard = /** @type {import('./product-card').ProductCard | null} */ (this.closest('product-card'));
//     const productLink = productCard?.getProductCardLink();

//     if (!productLink?.href) return '';

//     const url = new URL(productLink.href);

//     if (url.searchParams.has('variant')) {
//       return url.toString();
//     }

//     const selectedVariantId = this.#getSelectedVariantId();
//     if (selectedVariantId) {
//       url.searchParams.set('variant', selectedVariantId);
//     }

//     return url.toString();
//   }

//   /**
//    * Gets the currently selected variant ID from the product card
//    * @returns {string | null} The variant ID or null
//    */
//   #getSelectedVariantId() {
//     const productCard = /** @type {import('./product-card').ProductCard | null} */ (this.closest('product-card'));
//     return productCard?.getSelectedVariantId() || null;
//   }

//   connectedCallback() {
//     super.connectedCallback();

//     mediaQueryLarge.addEventListener('change', this.#closeQuickAddModal);
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();

//     mediaQueryLarge.removeEventListener('change', this.#closeQuickAddModal);
//     this.#abortController?.abort();
//   }

//   /**
//    * Handles quick add button click
//    * @param {Event} event - The click event
//    */
//   handleClick = async (event) => {
//     event.preventDefault();

//     const currentUrl = this.productPageUrl;

//     // Check if we have cached content for this URL
//     let productGrid = this.#cachedContent.get(currentUrl);

//     if (!productGrid) {
//       // Fetch and cache the content
//       const html = await this.fetchProductPage(currentUrl);
//       if (html) {
//         const gridElement = html.querySelector('[data-product-grid-content]');
//         if (gridElement) {
//           // Cache the cloned element to avoid modifying the original
//           productGrid = /** @type {Element} */ (gridElement.cloneNode(true));
//           this.#cachedContent.set(currentUrl, productGrid);
//         }
//       }
//     }

//     if (productGrid) {
//       // Use a fresh clone from the cache
//       const freshContent = /** @type {Element} */ (productGrid.cloneNode(true));
//       await this.updateQuickAddModal(freshContent);
//     }

//     this.#openQuickAddModal();
//   };

//   /** @param {QuickAddDialog} dialogComponent */
//   #stayVisibleUntilDialogCloses(dialogComponent) {
//     this.toggleAttribute('stay-visible', true);

//     dialogComponent.addEventListener(DialogCloseEvent.eventName, () => this.toggleAttribute('stay-visible', false), {
//       once: true,
//     });
//   }

//   #openQuickAddModal = () => {
//     const dialogComponent = document.getElementById('quick-add-dialog');
//     if (!(dialogComponent instanceof QuickAddDialog)) return;

//     this.#stayVisibleUntilDialogCloses(dialogComponent);

//     dialogComponent.showDialog();
//   };

//   #closeQuickAddModal = () => {
//     const dialogComponent = document.getElementById('quick-add-dialog');
//     if (!(dialogComponent instanceof QuickAddDialog)) return;

//     dialogComponent.closeDialog();
//   };

//   /**
//    * Fetches the product page content
//    * @param {string} productPageUrl - The URL of the product page to fetch
//    * @returns {Promise<Document | null>}
//    */
//   async fetchProductPage(productPageUrl) {
//     if (!productPageUrl) return null;

//     // We use this to abort the previous fetch request if it's still pending.
//     this.#abortController?.abort();
//     this.#abortController = new AbortController();

//     try {
//       const response = await fetch(productPageUrl, {
//         signal: this.#abortController.signal,
//       });

//       if (!response.ok) {
//         throw new Error(`Failed to fetch product page: HTTP error ${response.status}`);
//       }

//       const responseText = await response.text();
//       const html = new DOMParser().parseFromString(responseText, 'text/html');

//       return html;
//     } catch (error) {
//       if (error.name === 'AbortError') {
//         return null;
//       } else {
//         throw error;
//       }
//     } finally {
//       this.#abortController = null;
//     }
//   }

//   /**
//    * Re-renders the variant picker.
//    * @param {Element} productGrid - The product grid element
//    */
//   async updateQuickAddModal(productGrid) {
//     const modalContent = document.getElementById('quick-add-modal-content');

//     if (!productGrid || !modalContent) return;

//     if (isMobileBreakpoint()) {
//       const productDetails = productGrid.querySelector('.product-details');
//       const productFormComponent = productGrid.querySelector('product-form-component');
//       const variantPicker = productGrid.querySelector('variant-picker');
//       const productPrice = productGrid.querySelector('product-price');
//       const productTitle = document.createElement('a');
//       productTitle.textContent = this.dataset.productTitle || '';

//       // Make product title as a link to the product page
//       productTitle.href = this.productPageUrl;

//       const productHeader = document.createElement('div');
//       productHeader.classList.add('product-header');

//       productHeader.appendChild(productTitle);
//       if (productPrice) {
//         productHeader.appendChild(productPrice);
//       }
//       productGrid.appendChild(productHeader);

//       if (variantPicker) {
//         productGrid.appendChild(variantPicker);
//       }
//       if (productFormComponent) {
//         productGrid.appendChild(productFormComponent);
//       }

//       productDetails?.remove();
//     }

//     morph(modalContent, productGrid);

//     this.#syncVariantSelection(modalContent);
//   }

//   /**
//    * Syncs the variant selection from the product card to the modal
//    * @param {Element} modalContent - The modal content element
//    */
//   #syncVariantSelection(modalContent) {
//     const selectedVariantId = this.#getSelectedVariantId();
//     if (!selectedVariantId) return;

//     // Find and check the corresponding input in the modal
//     const modalInputs = modalContent.querySelectorAll('input[type="radio"][data-variant-id]');
//     for (const input of modalInputs) {
//       if (input instanceof HTMLInputElement && input.dataset.variantId === selectedVariantId && !input.checked) {
//         input.checked = true;
//         input.dispatchEvent(new Event('change', { bubbles: true }));
//         break;
//       }
//     }
//   }
// }

// if (!customElements.get('quick-add-component')) {
//   customElements.define('quick-add-component', QuickAddComponent);
// }

// class QuickAddDialog extends DialogComponent {
//   #abortController = new AbortController();

//   connectedCallback() {
//     super.connectedCallback();

//     this.addEventListener(ThemeEvents.cartUpdate, this.handleCartUpdate, { signal: this.#abortController.signal });
//     this.addEventListener(ThemeEvents.variantUpdate, this.#updateProductTitleLink);

//     this.addEventListener(DialogCloseEvent.eventName, this.#handleDialogClose);
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();

//     this.#abortController.abort();
//     this.removeEventListener(DialogCloseEvent.eventName, this.#handleDialogClose);
//   }

//   /**
//    * Closes the dialog
//    * @param {CartUpdateEvent} event - The cart update event
//    */
//   handleCartUpdate = (event) => {
//     if (event.detail.data.didError) return;
//     this.closeDialog();
//   };

//   #updateProductTitleLink = (/** @type {CustomEvent} */ event) => {
//     const anchorElement = /** @type {HTMLAnchorElement} */ (
//       event.detail.data.html?.querySelector('.view-product-title a')
//     );
//     const viewMoreDetailsLink = /** @type {HTMLAnchorElement} */ (this.querySelector('.view-product-title a'));
//     const mobileProductTitle = /** @type {HTMLAnchorElement} */ (this.querySelector('.product-header a'));

//     if (!anchorElement) return;

//     if (viewMoreDetailsLink) viewMoreDetailsLink.href = anchorElement.href;
//     if (mobileProductTitle) mobileProductTitle.href = anchorElement.href;
//   };

//   #handleDialogClose = () => {
//     const iosVersion = getIOSVersion();
//     /**
//      * This is a patch to solve an issue with the UI freezing when the dialog is closed.
//      * To reproduce it, use iOS 16.0.
//      */
//     if (!iosVersion || iosVersion.major >= 17 || (iosVersion.major === 16 && iosVersion.minor >= 4)) return;

//     requestAnimationFrame(() => {
//       /** @type {HTMLElement | null} */
//       const grid = document.querySelector('#ResultsList [product-grid-view]');
//       if (grid) {
//         const currentWidth = grid.getBoundingClientRect().width;
//         grid.style.width = `${currentWidth - 1}px`;
//         requestAnimationFrame(() => {
//           grid.style.width = '';
//         });
//       }
//     });
//   };
// }

// if (!customElements.get('quick-add-dialog')) {
//   customElements.define('quick-add-dialog', QuickAddDialog);
// }



import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { CartUpdateEvent, ThemeEvents } from '@theme/events';
import { DialogComponent, DialogCloseEvent } from '@theme/dialog';
import { mediaQueryLarge, isMobileBreakpoint, getIOSVersion } from '@theme/utilities';
import { SizeChartManager } from './size-chart.js';

export class QuickAddComponent extends Component {
  /** @type {AbortController | null} */
  #abortController = null;
  /** @type {Map<string, Element>} */
  #cachedContent = new Map();

  get productPageUrl() {
    const productCard = /** @type {import('./product-card').ProductCard | null} */ (this.closest('product-card'));
    const productLink = productCard?.getProductCardLink();

    if (!productLink?.href) return '';

    const url = new URL(productLink.href);

    if (url.searchParams.has('variant')) {
      return url.toString();
    }

    const selectedVariantId = this.#getSelectedVariantId();
    if (selectedVariantId) {
      url.searchParams.set('variant', selectedVariantId);
    }

    return url.toString();
  }

  /**
   * Gets the currently selected variant ID from the product card
   * @returns {string | null} The variant ID or null
   */
  #getSelectedVariantId() {
    const productCard = /** @type {import('./product-card').ProductCard | null} */ (this.closest('product-card'));
    return productCard?.getSelectedVariantId() || null;
  }

  connectedCallback() {
    super.connectedCallback();

    mediaQueryLarge.addEventListener('change', this.#closeQuickAddModal);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    mediaQueryLarge.removeEventListener('change', this.#closeQuickAddModal);
    this.#abortController?.abort();
  }

  /**
   * Handles quick add button click
   * @param {Event} event - The click event
   */
  handleClick = async (event) => {
    event.preventDefault();

    const currentUrl = this.productPageUrl;

    // Check if we have cached content for this URL
    let productGrid = this.#cachedContent.get(currentUrl);

    if (!productGrid) {
      // Fetch and cache the content
      const html = await this.fetchProductPage(currentUrl);
      if (html) {
        const gridElement = html.querySelector('[data-product-grid-content]');
        if (gridElement) {
          // Cache the cloned element to avoid modifying the original
          productGrid = /** @type {Element} */ (gridElement.cloneNode(true));
          this.#cachedContent.set(currentUrl, productGrid);
        }
      }
    }

    if (productGrid) {
      // Use a fresh clone from the cache
      const freshContent = /** @type {Element} */ (productGrid.cloneNode(true));
      await this.updateQuickAddModal(freshContent);
    }

    this.#openQuickAddModal();
  };

  /** @param {QuickAddDialog} dialogComponent */
  #stayVisibleUntilDialogCloses(dialogComponent) {
    this.toggleAttribute('stay-visible', true);

    dialogComponent.addEventListener(DialogCloseEvent.eventName, () => this.toggleAttribute('stay-visible', false), {
      once: true,
    });
  }

  #openQuickAddModal = () => {
    const dialogComponent = document.getElementById('quick-add-dialog');
    if (!(dialogComponent instanceof QuickAddDialog)) return;

    this.#stayVisibleUntilDialogCloses(dialogComponent);

    dialogComponent.showDialog();
  };

  #closeQuickAddModal = () => {
    const dialogComponent = document.getElementById('quick-add-dialog');
    if (!(dialogComponent instanceof QuickAddDialog)) return;

    dialogComponent.closeDialog();
    // Clear size chart when modal closes
    SizeChartManager.clearSizeChart();
  };

  /**
   * Fetches the product page content
   * @param {string} productPageUrl - The URL of the product page to fetch
   * @returns {Promise<Document | null>}
   */
  async fetchProductPage(productPageUrl) {
    if (!productPageUrl) return null;

    // We use this to abort the previous fetch request if it's still pending.
    this.#abortController?.abort();
    this.#abortController = new AbortController();

    try {
      const response = await fetch(productPageUrl, {
        signal: this.#abortController.signal,
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch product page: HTTP error ${response.status}`);
      }

      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      return html;
    } catch (error) {
      if (error.name === 'AbortError') {
        return null;
      } else {
        throw error;
      }
    } finally {
      this.#abortController = null;
    }
  }

  /**
   * Re-renders the variant picker.
   * @param {Element} productGrid - The product grid element
   */
  async updateQuickAddModal(productGrid) {
    const modalContent = document.getElementById('quick-add-modal-content');

    if (!productGrid || !modalContent) return;

    if (isMobileBreakpoint()) {
      const productDetails = productGrid.querySelector('.product-details');
      const productFormComponent = productGrid.querySelector('product-form-component');
      const variantPicker = productGrid.querySelector('variant-picker');
      const productPrice = productGrid.querySelector('product-price');
      const productTitle = document.createElement('a');
      productTitle.textContent = this.dataset.productTitle || '';

      // Make product title as a link to the product page
      productTitle.href = this.productPageUrl;

      const productHeader = document.createElement('div');
      productHeader.classList.add('product-header');

      productHeader.appendChild(productTitle);
      if (productPrice) {
        productHeader.appendChild(productPrice);
      }
      productGrid.appendChild(productHeader);

      if (variantPicker) {
        productGrid.appendChild(variantPicker);
      }
      if (productFormComponent) {
        productGrid.appendChild(productFormComponent);
      }

      productDetails?.remove();
    }

    morph(modalContent, productGrid);

    this.#syncVariantSelection(modalContent);

    // Load and render size chart for this product
    await this.#loadSizeChart();
  }

  /**
   * Loads size chart data from product metafields and renders it
   */
  async #loadSizeChart() {
    try {
      // First, try to get size chart from the cached/fetched HTML
      const sizeChartData = await this.#getSizeChartFromHTML();
      
      if (sizeChartData && sizeChartData.length > 0) {
        SizeChartManager.renderSizeChart(sizeChartData);
        return;
      }

      // Fallback: Try to fetch from product API
      const productHandle = this.#extractProductHandle(this.productPageUrl);
      if (!productHandle) {
        SizeChartManager.clearSizeChart();
        return;
      }

      const productData = await this.#fetchProductData(productHandle);
      if (!productData) {
        SizeChartManager.clearSizeChart();
        return;
      }

      // Extract size chart data from metafields
      const apiSizeChartData = this.#extractSizeChartData(productData);
      if (!apiSizeChartData || apiSizeChartData.length === 0) {
        SizeChartManager.clearSizeChart();
        return;
      }

      // Render the size chart
      SizeChartManager.renderSizeChart(apiSizeChartData);
    } catch (error) {
      console.error('Error loading size chart:', error);
      SizeChartManager.clearSizeChart();
    }
  }

  /**
   * Attempts to extract size chart data from the fetched HTML
   * @returns {Promise<Array|null>} Size chart data array
   */
  async #getSizeChartFromHTML() {
    try {
      // Get the current URL to fetch the product page
      const currentUrl = this.productPageUrl;
      if (!currentUrl) return null;

      // Fetch the product page HTML
      const html = await this.fetchProductPage(currentUrl);
      if (!html) return null;

      // Method 1: Look for size chart data in script tags with JSON data
      const scripts = html.querySelectorAll('script[type="application/json"], script[data-size-chart], script[id*="product"]');
      
      for (const script of scripts) {
        try {
          const textContent = script.textContent?.trim();
          if (!textContent) continue;
          
          const data = JSON.parse(textContent);
          
          // Check various possible structures
          if (data.product?.metafields?.custom?.size_chart_data_new?.value) {
            const value = data.product.metafields.custom.size_chart_data_new.value;
            return Array.isArray(value) ? value : [value];
          }
          
          if (data.metafields?.custom?.size_chart_data_new?.value) {
            const value = data.metafields.custom.size_chart_data_new.value;
            return Array.isArray(value) ? value : [value];
          }

          // Check for size chart data attribute
          if (data.sizeChartData) {
            return Array.isArray(data.sizeChartData) ? data.sizeChartData : [data.sizeChartData];
          }
        } catch (e) {
          // Continue to next script
        }
      }

      // Method 2: Look for data attribute on product grid or product container
      const productContainer = html.querySelector('[data-product-id], [data-size-chart]');
      if (productContainer) {
        const sizeChartAttr = productContainer.getAttribute('data-size-chart');
        if (sizeChartAttr) {
          try {
            const chartData = JSON.parse(sizeChartAttr);
            return Array.isArray(chartData) ? chartData : [chartData];
          } catch (e) {
            // If it's not JSON, treat as comma-separated URLs
            return sizeChartAttr.split(',').map(url => url.trim()).filter(Boolean);
          }
        }
      }

      // Method 3: Look for size chart images directly in the HTML
      // This would work if the size chart snippet is rendered in the product page
      const sizeChartImages = html.querySelectorAll('[data-size-chart-image], .size-chart-img');
      if (sizeChartImages.length > 0) {
        return Array.from(sizeChartImages).map(img => {
          const dataUrl = img.getAttribute('data-size-chart-image');
          return dataUrl || img.src || img.getAttribute('src');
        }).filter(Boolean);
      }

      return null;
    } catch (error) {
      console.error('Error extracting size chart from HTML:', error);
      return null;
    }
  }

  /**
   * Extracts product handle from URL
   * @param {string} url - Product page URL
   * @returns {string|null} Product handle
   */
  #extractProductHandle(url) {
    try {
      const urlObj = new URL(url);
      const pathParts = urlObj.pathname.split('/').filter(Boolean);
      const productsIndex = pathParts.indexOf('products');
      if (productsIndex !== -1 && pathParts[productsIndex + 1]) {
        return pathParts[productsIndex + 1];
      }
      return null;
    } catch (error) {
      return null;
    }
  }

  /**
   * Fetches product data including metafields from Shopify
   * @param {string} productHandle - Product handle
   * @returns {Promise<Object|null>} Product data
   */
  async #fetchProductData(productHandle) {
    try {
      const response = await fetch(`/products/${productHandle}.js`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch product: HTTP error ${response.status}`);
      }

      const productData = await response.json();
      return productData;
    } catch (error) {
      console.error('Error fetching product data:', error);
      return null;
    }
  }

  /**
   * Extracts size chart data from product data
   * @param {Object} productData - Product data from Shopify API
   * @returns {Array|null} Size chart data array
   */
  #extractSizeChartData(productData) {
    // Try to get metafields from the product data
    // Shopify's product.js endpoint may not include metafields by default
    // We'll need to check the structure and extract accordingly
    
    if (productData.metafields && productData.metafields.custom && productData.metafields.custom.size_chart_data_new) {
      const metafield = productData.metafields.custom.size_chart_data_new;
      if (metafield.value) {
        // If it's an array of image URLs
        if (Array.isArray(metafield.value)) {
          return metafield.value;
        }
        // If it's a single value, wrap it in an array
        if (metafield.value) {
          return [metafield.value];
        }
      }
    }

    // Check alternative structure (direct metafields property)
    if (productData.metafields) {
      const sizeChartMetafield = productData.metafields.find(
        mf => mf.namespace === 'custom' && mf.key === 'size_chart_data_new'
      );
      if (sizeChartMetafield && sizeChartMetafield.value) {
        const value = sizeChartMetafield.value;
        return Array.isArray(value) ? value : [value];
      }
    }

    return null;
  }

  /**
   * Syncs the variant selection from the product card to the modal
   * @param {Element} modalContent - The modal content element
   */
  #syncVariantSelection(modalContent) {
    const selectedVariantId = this.#getSelectedVariantId();
    if (!selectedVariantId) return;

    // Find and check the corresponding input in the modal
    const modalInputs = modalContent.querySelectorAll('input[type="radio"][data-variant-id]');
    for (const input of modalInputs) {
      if (input instanceof HTMLInputElement && input.dataset.variantId === selectedVariantId && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        break;
      }
    }
  }
}

if (!customElements.get('quick-add-component')) {
  customElements.define('quick-add-component', QuickAddComponent);
}

class QuickAddDialog extends DialogComponent {
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener(ThemeEvents.cartUpdate, this.handleCartUpdate, { signal: this.#abortController.signal });
    this.addEventListener(ThemeEvents.variantUpdate, this.#updateProductTitleLink);

    this.addEventListener(DialogCloseEvent.eventName, this.#handleDialogClose);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#abortController.abort();
    this.removeEventListener(DialogCloseEvent.eventName, this.#handleDialogClose);
  }

  /**
   * Closes the dialog
   * @param {CartUpdateEvent} event - The cart update event
   */
  handleCartUpdate = (event) => {
    if (event.detail.data.didError) return;
    this.closeDialog();
  };

  #updateProductTitleLink = (/** @type {CustomEvent} */ event) => {
    const anchorElement = /** @type {HTMLAnchorElement} */ (
      event.detail.data.html?.querySelector('.view-product-title a')
    );
    const viewMoreDetailsLink = /** @type {HTMLAnchorElement} */ (this.querySelector('.view-product-title a'));
    const mobileProductTitle = /** @type {HTMLAnchorElement} */ (this.querySelector('.product-header a'));

    if (!anchorElement) return;

    if (viewMoreDetailsLink) viewMoreDetailsLink.href = anchorElement.href;
    if (mobileProductTitle) mobileProductTitle.href = anchorElement.href;
  };

  #handleDialogClose = () => {
    // Clear size chart when dialog closes
    SizeChartManager.clearSizeChart();

    const iosVersion = getIOSVersion();
    /**
     * This is a patch to solve an issue with the UI freezing when the dialog is closed.
     * To reproduce it, use iOS 16.0.
     */
    if (!iosVersion || iosVersion.major >= 17 || (iosVersion.major === 16 && iosVersion.minor >= 4)) return;

    requestAnimationFrame(() => {
      /** @type {HTMLElement | null} */
      const grid = document.querySelector('#ResultsList [product-grid-view]');
      if (grid) {
        const currentWidth = grid.getBoundingClientRect().width;
        grid.style.width = `${currentWidth - 1}px`;
        requestAnimationFrame(() => {
          grid.style.width = '';
        });
      }
    });
  };
}

if (!customElements.get('quick-add-dialog')) {
  customElements.define('quick-add-dialog', QuickAddDialog);
}
